import React from 'react';
export function HeroSection() {
  return <section className="w-full bg-navy py-16 md:py-24 px-4" data-id="element-154">
      <div className="max-w-4xl mx-auto text-center" data-id="element-155">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6" data-id="element-156">
          ¿Duermes 7 u 8 horas…
          <br data-id="element-157" />y aun así despiertas agotado?
        </h1>

        <p className="text-xl md:text-2xl text-cyan leading-relaxed mb-6" data-id="element-158">
          El problema no es cuánto duermes.
          <br data-id="element-159" />
          Es que tu sistema nervioso
          <br data-id="element-160" />
          nunca entra en descanso real.
        </p>

        <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto mb-10" data-id="element-161">
          Millones de personas se acuestan, cierran los ojos… y su cerebro sigue
          en modo alerta toda la noche.
          <br data-id="element-162" />
          Duermes. Pero no recuperas.
        </p>

        <div className="mb-10" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/hY2jRSXJfE7JrLSyrvaahh/portada.png" alt="Duermes Pero No Descansas - Producto digital" className="max-w-full md:max-w-2xl mx-auto rounded-lg shadow-2xl" data-id="element-164" />
        </div>

        <a href="#comprar" className="inline-block animate-pulse-cta bg-cta text-navy font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-full hover:bg-cta/90 transition-colors mb-6" data-id="element-165">
          Quiero descansar de verdad →
        </a>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm text-white/80" data-id="element-166">
          <span data-id="element-167">🔒 Pago seguro</span>
          <span data-id="element-168">⚡ Descarga inmediata</span>
          <span data-id="element-169">🛡️ Garantía 30 días</span>
        </div>
      </div>
    </section>;
}